import React from 'react'

const Map = () => {
  return (
    <div>
      <iframe className='w-full h-96' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12230.681131628835!2d-75.1402333!3d39.9711239!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6c9c72e58cd95%3A0x620df66ff5627aee!2sArtistry%20Spa%20%26%20Wellness!5e0!3m2!1sen!2s!4v1730102877478!5m2!1sen!2s" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  )
}

export default Map
